import React, { Component } from "react";
import {
  Modal,
  Card,
  Col,
  Row,
  Form,
  Button,
  Table,
  Spinner,
} from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { RiShareBoxLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { FaTrashAlt, FaDownload, FaEdit, FaStreetView } from "react-icons/fa";
import Currency from "../../../../Function/currency.json";
// import * as JobOptions from '../../../../Function/defaultJobOptions'
import { revenuecostService } from "../../../../Services/revenuecostService";
import InvoiceHtml from "../../../../Function/Invoice";
import JobService from "../../../../Services/JobService";
import EditInvoice from "./EditInvoice";
import { jsPDF } from "jspdf";
import { renderToString } from "react-dom/server";
import PdfDownload from "../../../../Function/PdfDownload";
import helperFunction from "../../../../Function/helperFunction";

// const jobItemOption = [
//     { value: "", label: "Select" },
//     { value: "air", label: "Air Freight" },
//     { value: "sea", label: "Sea Freight" },
//     { value: "land", label: "Land Freight" },
//     { value: "courier", label: "Courier Freight" },
//     { value: "packing", label: "Packing" },
//     { value: "insurance", label: "Insurance" },
//     { value: "storage", label: "Storage" },
//     { value: "other", label: "Other" },
// ]

const jobItemOption = [
  { value: "", label: "Select" },
  { value: "AIR FREIGHT CHARGES", label: "AIR FREIGHT CHARGES" },
  { value: "SEA FREIGHT CHARGES", label: "SEA FREIGHT CHARGES" },
  { value: "LAND FREIGHT CHARGES", label: "LAND FREIGHT CHARGES" },
  { value: "COURIER CHARGES", label: "COURIER CHARGES" },
  { value: "LOCAL TRANSPORTATION", label: "LOCAL TRANSPORTATION" },
  { value: "PACKING CHARGES", label: "PACKING CHARGES" },
  { value: "INSURANCE PREMIUM", label: "INSURANCE PREMIUM" },
  { value: "STORAGES CHARGES", label: "STORAGES CHARGES" },
  { value: "OTHER SERVICES", label: "OTHER SERVICES" },
];

const DeleteModal = ({ modalShow, handleDeleteShow, handleDelete }) => {
  return (
    <Modal
      size="sm"
      show={modalShow}
      onHide={() => handleDeleteShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Delete Invoice?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>Do you want to delete this invoice?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleDeleteShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={() => handleDelete()}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

class Revenue extends Component {
  state = {
    buttonSubmit: true,
    showModal: false,
    showEditInvoicesModal: false,
    showDeleteModal: false,
    deletedInvoiceId: { id: "", qid: "" },
    borderStyle: { borderRight: "1px solid #ddd" },
    agreedAmt: 0,
    // advnceAmt: 0,
    invoiceView: 0,
    revenueObj: {
      item: [
        {
          item_name: "",
          rate_per_qty: "",
          other_amount: "",
          currency: { cc: "AED" },
          description: "",
          ex_rate: 1,
          lc_amount: "",
          vat: 2,
          taxable_amount: "",
          glc_amount: "",
        },
      ],
    },
    invoices: [],
    invoicePdfState: [],
    revenueItem: [
      {
        item_name: "",
        other_amount: "",
        rate_per_qty: "",
        currency: { cc: "AED" },
        description: "",
        ex_rate: 1,
        lc_amount: "",
        vat: 2,
        taxable_amount: "",
        glc_amount: "",
      },
    ],
    loadingPdf: false,
  };
  componentDidMount() {
    this.getInvoices();
    this.getRevForms();
  }

  getInvoices = () => {
    let jId = this.props.jobId;
    jId &&
      revenuecostService.getInvoice({ jId }).then((result) => {
        if (result.status === true) {
          let apiData = result?.data;
          let findInvoice= result.data.length>0 ? result.data.map((item)=> item.draft).includes(true) ? true : false : true
          // let findInvoice= result?.data.find(
          //   (item) => item.draft === false
          // )
        this.props.checkInvoice(findInvoice)
          let totalAgreedAmount = apiData.reduce(
            (total, item) => total + item.gross_amount,
            0
          );
          let invoicepdfstate = result.data.map((acc, cur) => {
            acc[cur._id] = false;
            return acc;
          }, {});
          this.setState(
            {
              invoices: result.data,
              invoicePdfState: invoicepdfstate,
              agreedAmt: totalAgreedAmount,
            },
            () => {
              this.props.onChangeValue(
                { value: totalAgreedAmount },
                "payment_information",
                "agreed_amount"
              );
            }
          );
        }
      });
  };

  getRevForms = () => {
    const { buttonSubmit, revenueItem } = this.state;

    return (
      <>
        <Form ref={(el) => (this.myFormRef = el)}>
          <Row>
            {revenueItem.map((item, index) => {
              return (
                <Row className="customNoLineBreak" key={index}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Job Item</Form.Label>
                      <Form.Select
                        name="item_name"
                        onChange={(e) => this.handleInputChange(e, index)}
                      >
                        {jobItemOption.map((option, index) => {
                          if (item.item_name === option.value) {
                            return (
                              <option key={index} selected value={option.value}>
                                {option.label}
                              </option>
                            );
                          } else {
                            return (
                              <option key={index} value={option.value}>
                                {option.label}
                              </option>
                            );
                          }
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        name="description"
                        value={item.description}
                        onChange={(e) => this.handleInputChange(e, index)}
                      />
                    </Form.Group>
                  </Col>
                  <div className="px-2" style={{ maxWidth: 120 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Currency</Form.Label>
                      <Form.Select
                        name="currency"
                        value={item.currency?.cc}
                        onChange={(e) => this.handleInputChange(e, index)}
                      >
                        <option>Currency</option>

                        {Currency.map((item,i) => {
                          return (
                            <option key={i} value={item.cc}>
                              {/* {item.cc} ({item.symbol}) */}
                              {item.cc}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 80 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>FC Amount</Form.Label>
                      <Form.Control
                        name="rate_per_qty"
                        value={item.rate_per_qty}
                        onChange={(e) => this.handleInputChange(e, index)}
                      />
                    </Form.Group>
                  </div>

                  <div className="px-3" style={{ maxWidth: 90 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Ex Rate</Form.Label>
                      <Form.Control
                        name="ex_rate"
                        min="1"
                        type="number"
                        value={item.ex_rate}
                        onChange={(e) => this.handleInputChange(e, index)}
                      />
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 90 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>LC Amount</Form.Label>
                      <Form.Control
                        name="lc_amount"
                        value={item.lc_amount}
                        onChange={(e) => this.handleInputChange(e, index)}
                        readOnly
                      />
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 90 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Vat</Form.Label>
                      <Form.Select
                        name="vat"
                        defaultValue={2}
                        onChange={(e) => this.handleInputChange(e, index)}
                      >
                        {/* <option value={0}>Select</option> */}

                        <option value={2}>Zero-Rated</option>
                        <option value={4}>Exempt From VAT</option>
                        <option value={12}>
                          SR Standard Rated (DXB) SS-DXB
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 90 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>VAT amount</Form.Label>
                      <Form.Control
                        name="vat_amount"
                        value={item.taxable_amount}
                        readOnly
                      />
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 120 }}>
                    <Form.Group className="mb-3">
                      <Form.Label>Gross LC Amount</Form.Label>
                      <Form.Control
                        name="glc_amount"
                        value={item.glc_amount}
                        onChange={(e) => this.handleInputChange(e, index)}
                        readOnly
                      />
                    </Form.Group>
                  </div>

                  <div className="px-2" style={{ maxWidth: 80 }}>
                  {
                    !this.props.isview &&
                    <Button
                      className="mt-4"
                      variant="danger"
                      size="sm"
                      onClick={() => this.handleRemoveItem(index)}
                    >
                      <FaTrashAlt />
                    </Button>
                  }
                    {/* {index !== 0 && (
                                           
                                        )} */}
                  </div>
                </Row>
              );
            })}

            {/* <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Type</Form.Label>
                            <Form.Control
                                name="type"
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </Form.Group>
                    </Col> */}

            <Col md={2} className="mt-3">
            {
              !this.props.isview &&
              <Button
                variant="success"
                size="sm"
                onClick={() => this.handleAddItem()}
              >
                Add Item
              </Button>
            }
            </Col>
          </Row>
          <Row className="mt-3">
            {/* <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control
                                name="quantity"
                                onChange={(e) => this.handleInputChange(e)}
                            />
                        </Form.Group>
                    </Col> */}

            {/* <Col md={2}>
              <div className="col-12">
                <div className="">
                  <label className="form-label">Date</label>
                  <input
                    className="form-control form-control-sm"
                    name="created_date"
                    type="date"
                    // value={item.remark}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
              </div>
            </Col> */}
            <Col md={6}>
              <div className="col-12">
                <div className="">
                  <label className="form-label">Remark</label>
                  <textarea
                    className="form-control form-control-sm"
                    name="remark"
                    // value={item.remark}
                    onChange={(e) => this.handleInputChange(e)}
                  />
                </div>
              </div>
            </Col>
            {/* <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select aria-label="Default select example" name="status" onChange={(e) => this.handleInputChange(e)}>
                                <option>Select status</option>
                                <option value="paid">Paid</option>
                                <option value="unpaid">Unpaid</option>
                            </Form.Select>
                            </Form.Group>
                        </Col> */}

            <Col md={2} className="mt-4">
              {/* {this.props.jobStatus !== "DELIVERED" && buttonSubmit && ( */}
              {
                !this.props.isview &&
              <Button variant="warning" onClick={() => this.createInvoice()}>
                Add Revenue
              </Button>
              }
              {/* )} */}

              {!buttonSubmit && (
                <Button variant="primary" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </Button>
              )}
            </Col>

            <Col className="mt-4">
              Agreed Amount:{" "}
              {this.state.agreedAmt
                ? helperFunction.handleDecimalPoints(this.state.agreedAmt, 3)
                : this.state.agreedAmt}
            </Col>
          </Row>
        </Form>
      </>
    );
  };

  handleAddItem = () => {
    let revItems = this.state.revenueObj;
    let item = [
      ...this.state.revenueItem,
      {
        item_name: "",
        rate_per_qty: "",
        currency: { cc: "AED" },
        description: "",
        ex_rate: 1,
        lc_amount: "",
        vat: "2",
        taxable_amount: "",
        glc_amount: "",
      },
    ];
    revItems.item = item;

    this.setState({ revenueObj: revItems, revenueItem: item });
  };

  handleRemoveItem = (index) => {
    const itemList = [...this.state.revenueItem];
    itemList.splice(index, 1);
    this.setState({ revenueItem: itemList });
  };

  handleInputChange(e, index = "") {
    const { name, value } = e.target;
    let rObj = this.state.revenueObj;
    let rItem = this.state.revenueItem;

    if (index !== "") {
      // To set value in to state
      rObj["item"][index][name] = value;
      rItem[index][name] = value;

      if (name === "item_name") {
        rItem[index]["description"] = value;
        rObj["item"][index]["description"] = value;
        if (value === "OTHER SERVICES") {
          rItem[index]["other_amount"] = rItem[index]["rate_per_qty"];
          rObj["item"][index]["other_amount"] =
            rObj["item"][index]["rate_per_qty"];
        } else {
          rItem[index]["other_amount"] = "";
          rObj["item"][index]["other_amount"] = "";
        }
      }

      if (name === "currency") {
        rItem[index]["currency"] = { cc: value };
        rObj["item"][index]["currency"] = { cc: value };
      }

      if (name === "rate_per_qty") {
        let rpq = value;
        let exRate = rObj["item"][index]["ex_rate"];
        let lcAmt = (rpq * exRate).toFixed(2); //code by sd client req
        let vat = rObj["item"][index]["vat"];
        let vatPer = vat === "12" ? 5 : 0;

        let gcAmtPercent = 0;
        if (vatPer !== 0) {
          gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
        } else {
          rItem[index]["vat"] = 2;
        }
        let gcAmt = Number(gcAmtPercent) + Number(lcAmt);
        if (rItem[index]["item_name"] === "OTHER SERVICES") {
          rItem[index]["other_amount"] = value;
          rObj["item"][index]["other_amount"] = value;
        } else {
          rItem[index]["other_amount"] = "";
          rObj["item"][index]["other_amount"] = "";
        }
        rItem[index]["lc_amount"] = lcAmt;
        rItem[index]["glc_amount"] = gcAmt;
        rItem[index]["taxable_amount"] = gcAmtPercent;
        rObj["item"][index]["lc_amount"] = lcAmt;
        rObj["item"][index]["glc_amount"] = gcAmt;
        rObj["item"][index]["taxable_amount"] = gcAmtPercent;

        this.setAgreedAmt();
      }

      // Calculate and set for LC amount and Gross LC amount
      if (name === "ex_rate") {
        let ex_rate_val = value;
        let vat = rObj["item"][index]["vat"];
        let vatPer = vat === "12" ? 5 : 0;
        if (value && Number(value) === 0) {
          rItem[index]["ex_rate"] = Number(1);
          rObj["item"][index]["ex_rate"] = Number(1);
          ex_rate_val = 1;
        }

        let rpq = rObj["item"][index]["rate_per_qty"];
        let lcAmt = (rpq * ex_rate_val).toFixed(2);
        rItem[index]["lc_amount"] = lcAmt;
        rItem[index]["glc_amount"] = lcAmt;
        rObj["item"][index]["lc_amount"] = lcAmt;

        // let gcAmtPercent = (lcAmt * ex_rate_val) / 100;
        let gcAmtPercent = 0;
        if (vatPer === 0) {
          gcAmtPercent = 0;
        } else {
          gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
        }
        let total = Number(lcAmt);
        if (vatPer && vatPer !== 0) {
          rItem[index]["taxable_amount"] = gcAmtPercent;
          rObj["item"][index]["taxable_amount"] = gcAmtPercent;

          total = Number(lcAmt) + Number(gcAmtPercent);
        }
        rObj["item"][index]["glc_amount"] = total;
        rItem[index]["glc_amount"] = total;

        this.setAgreedAmt();
      }

      if (name === "vat" && value !== 0) {
        let lcAmt = rObj["item"][index]["lc_amount"];

        // Currenly 2, 4 and 12 is ID of the tax(in quickbook)
        // ID 2 and 4 has 0% and 12 has 5%
        let vatPer = value === "12" ? 5 : 0;
        let gcAmtPercent = 0;
        if (vatPer === 0) {
          gcAmtPercent = 0;
        } else {
          gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
        }

        let gcAmt = Number(gcAmtPercent) + Number(lcAmt);
        rItem[index]["glc_amount"] = gcAmt;
        rItem[index]["taxable_amount"] = gcAmtPercent;
        rItem[index]["vat"] = value;
        rObj["item"][index]["glc_amount"] = gcAmt;
        rObj["item"][index]["taxable_amount"] = gcAmtPercent;

        this.setAgreedAmt();
      }
    } else {
      rObj[name] = value;
    }

    this.setState({ revenueObj: rObj, revenueItem: rItem });
  }

  setAgreedAmt = () => {
    let rObj = this.state.revenueObj;
    let sum = rObj.item.reduce((total, i) => total + Number(i.glc_amount), 0);
    let totalAgreedAmount = Number(this.props.payInfoData.agreed_amount) + sum;

    // this.setState({ agreedAmt: totalAgreedAmount})
  };

  /* handleUpdateStatus(e, id, totalAmt, invoiceId) {
          const { name, value } = e.target
          let postData = {}
          postData.id = id
          postData.status = value
  
          revenuecostService.updateStatus(postData).then(result => {
              if (result.status === true) {
                  let invoiceReq = {
                      email : this.props.customerData.email,
                      totalAmt,
                      invoiceId,
                      jobId : this.props.jobId
                  }
                  revenuecostService.invoicePayment(invoiceReq).then(invoiceRes => {
                      if (invoiceRes.status === true) {
                          toast.success(result.message);
                          this.getInvoices()
                      }
                  })
              }
          })
      } */

  resetRevForm = () => {
    this.setState({});
  };

  billingParty = () => {
    const raw = this.props.jobData;
    const fromProp = Array.isArray(raw) ? (raw[0] || {}) : (raw || {});
    if (fromProp.retailer_email || fromProp.email) return fromProp;
    const stored = this.props.bookingData && this.props.bookingData.retailer_details;
    return Array.isArray(stored) ? (stored[0] || {}) : (stored || {});
  };

  billingEmail = () => {
    const retailer = this.billingParty();
    return retailer.retailer_email || retailer.email || "";
  };

  billingCustomer = () => {
    const retailer = this.billingParty();
    return {
      ...(this.props.customerData || {}),
      email: this.billingEmail(),
      name: retailer.retailer_name || retailer.contact_name || retailer.name || this.props.customerData?.name || "",
    };
  };

  addtoQuickBook = (selRevenueObj) => {
    let revData = selRevenueObj;
    let revenueFinalItems = revData.item;
    revenueFinalItems = revenueFinalItems.filter(
      (item) => item.glc_amount !== ""
    );
    let quickbookData = [];
    let totalAmt = revData.item.reduce(
      (total, item) => Number(item.glc_amount) + total,
      0
    );
    if (this.props.payInfoData?.quickbook_payment?.length > 0) {
      this.props.payInfoData.job_advance_payment === 0
        ? (revData.status = "unpaid")
        : (revData.status = "partial");
      let amt = 0;
      quickbookData = this.props.payInfoData?.quickbook_payment.map((item) => {
        amt = Number(amt) + Number(item?.amount);
        return { TxnId: item?.TxnId, TxnType: item?.TxnType };
      });
      revData.paid = amt;
      revData.balance = Number(totalAmt) - Number(amt);
    }

    let postData = {};
    postData.rate_per_qty = revData.rate_per_qty;
    postData.job_id = this.props.jobId;
    postData.job_token = this.props.jobToken;
    postData.email = this.billingEmail();
    postData.mobile_number = this.props.jobData?.phone_number || this.props.jobData?.mobile_number || this.props.customerData.mobile_number;
    postData.name = this.props.jobData?.retailer_name || this.props.jobData?.name || this.props.customerData.name;
    postData.item = revenueFinalItems;
    postData.invoice_number = revData.invoice_number;
    postData.created_date = revData.created_date;

    revData.job_id = this.props.jobId;
    revData.gross_amount = totalAmt;
    revData.customer_email = this.billingEmail();
    revData.item = revenueFinalItems;

    postData.quickbook_payment = quickbookData;

    var invoiceUpdate = {};
    invoiceUpdate.draft = false;
    invoiceUpdate.id = revData._id;
    invoiceUpdate.item = revData.item;
    invoiceUpdate.gross_amount = totalAmt
      ? helperFunction.handleDecimalPoints(totalAmt, 3)
      : totalAmt;
    revenuecostService.invoiceCreateQB(postData).then((result) => {
      if (result.status === true) {
        invoiceUpdate.quickBookdata = {
          invoice_id: result.data.json.Invoice.Id,
          json: result.data,
        };
        revenuecostService.updateInvoice(invoiceUpdate).then((result1) => {
          if (result1.status === true) {
            toast.success(result1.message);
            this.getInvoices(); // Get latest data/invoice
            this.props.profitNLoss();
          } else {
            if (result1.data) {
              toast.error("Quickbook error :" + result1.data);
            }
          }
          this.setState({ buttonSubmit: true });
        });
      } else {
        this.setState({ buttonSubmit: true });
        if (result.data.error_description) {
          toast.error("Quickbook error :" + result.data.error_description);
        }
      }
    });
  };

  createInvoice = () => {
    let revData = this.state.revenueObj;
    const findExist = revData.item.find((itm)=> !itm?.lc_amount || !itm?.item_name)
    if(findExist) return false

    this.setState({ buttonSubmit: false });
    //get quick book payments
    let quickbookData = [];
    revData.status = "unpaid";
    let totalAmt = revData.item.reduce(
      (total, item) => Number(item.glc_amount) + total,
      0
    );
    if (this.props.payInfoData?.quickbook_payment?.length > 0) {
      this.props.payInfoData.job_advance_payment === 0
        ? (revData.status = "unpaid")
        : (revData.status = "partial");
      let amt = 0;
      quickbookData = this.props.payInfoData?.quickbook_payment.map((item) => {
        amt = Number(amt) + Number(item?.amount);
        return { TxnId: item?.TxnId, TxnType: item?.TxnType };
      });
      revData.paid = amt;
      revData.balance = Number(totalAmt) - Number(amt);
    }

    let revenueFinalItems = revData.item;
    revenueFinalItems = revenueFinalItems.filter(
      (item) => item.glc_amount !== ""
    );

    // let postData = {};
    // postData.rate_per_qty = revData.rate_per_qty;
    // postData.job_id = this.props.jobId;
    // postData.job_token = this.props.jobToken;
    // postData.email = this.props.customerData.email;
    // postData.mobile_number = this.props.customerData.mobile_number;
    // postData.name = this.props.customerData.name;
    // postData.item = revenueFinalItems;

    revData.job_id = this.props.jobId; // For invoice collection/table
    //revData.status = 'unpaid'
    revData.gross_amount = totalAmt;
    //revData.balance = totalAmt
    //change for api not work
    revData.customer_email = this.billingEmail();
    //end
    revData.item = revenueFinalItems;
    revData.draft = true;

    // postData.quickbook_payment = quickbookData;

    // revenuecostService.invoiceCreateQB(postData).then((result) => {
    //     if (result.status === true) {
    //         revData.quickBookdata = {
    //             invoice_id: result.data.json.Invoice.Id,
    //             json: result.data,
    //         };

    revenuecostService.createInvoice(revData).then((invoiceRes) => {
      if (invoiceRes.status === true) {
        toast.success(invoiceRes.message);
        this.setState({
          buttonSubmit: true,
          revenueObj: {
            item: [
              {
                item_name: "",
                rate_per_qty: "",
                other_amount: "",
                currency: { cc: "AED" },
                description: "",
                ex_rate: 1,
                lc_amount: "",
                vat: 2,
                taxable_amount: "",
                glc_amount: "",
              },
            ],
          },
          revenueItem: [
            {
              item_name: "",
              other_amount: "",
              rate_per_qty: "",
              currency: { cc: "AED" },
              description: "",
              ex_rate: 1,
              lc_amount: "",
              vat: 2,
              taxable_amount: "",
              glc_amount: "",
            },
          ],
        });

        this.myFormRef.reset(); // Reset form
        this.getInvoices(); // Get latest data/invoice
        this.props.profitNLoss();
      }
    });
    //     } else {
    //         this.setState({ buttonSubmit: true });
    //         if (result.data.error_description) {
    //             toast.error("Quickbook error :" + result.data.error_description);
    //         }
    //     }
    // });

    // let rObj = this.state.revenueObj
    // let sum = rObj.item.reduce((total, i) => total + Number(i.glc_amount), 0)
    // let totalAgreedAmount = Number(this.props.payInfoData.agreed_amount) + sum

    let totalAgreedAmount = Number(this.state.agreedAmt) + Number(totalAmt);
    // let totalAdvanceAmount = Number(this.state.advnceAmt);

    let otherArr = this.state.revenueItem.filter(
      (item) => item.item_name === "OTHER SERVICES"
    );
    let totalOther = 0;
    for (let i = 0; i < otherArr.length; i++) {
      totalOther += Number(otherArr[i].other_amount);
    }

    this.props.onChangeValue(
      { value: totalAgreedAmount },
      "payment_information",
      "agreed_amount"
    );
    this.props.onChangeValue(
      { value: 0 },
      "payment_information",
      "job_advance_payment"
    );
    this.props.onChangeValue(
      { value: totalOther },
      "payment_information",
      "other_amount"
    );

    let jId = this.props.jobId;
    if (jId) {
      let updateAgr = {
        jId,
        agreedAmt: totalAgreedAmount,
      };

      JobService.updatePaymentInfo(updateAgr).then((result) => {
        if (result.status === true) {
          // toast.success(result.message);
        }
      });
    }
  };

  handleShow = (value, index) => {
    if (value === true) {
      this.setState({ showModal: value, invoiceView: index });
    } else {
      this.setState({ showModal: value });
    }
  };

  handleShowEditInvoide = (value, index) => {
    if (value === true) {
      this.setState({ showEditInvoicesModal: value, invoiceView: index });
    } else {
      this.setState({ showEditInvoicesModal: value });
    }
    this.getInvoices(); // Get latest data/invoice
  };

  handleDeleteShow = (value) => {
    this.setState({ showDeleteModal: value });
  };

  handleDelete = () => {
    const { deletedInvoiceId } = this.state;
    if (deletedInvoiceId?.qid) {
      revenuecostService
        .invoiceDeleteQB({ id: deletedInvoiceId.qid })
        .then((result) => {
          if (result.status) {
            this.deleteInvoice();
          } else {
            toast.error("error");
          }
        });
    } else {
      this.deleteInvoice();
    }
  };

  deleteInvoice = () => {
    const { deletedInvoiceId } = this.state;
    revenuecostService
      .deleteInvoice({ id: deletedInvoiceId.id })
      .then((res) => {
        if (res.status) {
          toast.success(res.message);
          this.getInvoices();
          this.handleDeleteShow(false);
        } else {
          toast.error(res.message);
        }
      });
  };

  downloadPdf = async (
    invoices,
    invoiceView,
    quoteToken,
    carrierData,
    receiverData,
    customerData,
    jobId,
    bookingData,
    itemid
  ) => {
    this.setState({ loadingPdf: true });
    const doc = new jsPDF();
    let thisstateinvoice = { ...this.state.invoicePdfState, [itemid]: true };
    this.setState({ invoicePdfState: thisstateinvoice });
    // 'p','pt', [800, 800]

    const string = renderToString(
      <PdfDownload
        invoiceItem={invoices[invoiceView]}
        quoteToken={quoteToken}
        carrierData={carrierData}
        receiverData={receiverData}
        customerData={customerData}
        jobId={jobId}
        bookingData={bookingData}
      />
    );

    await doc.html(string, {
      async callback(doc) {
        doc.save("W2D_" + invoices[invoiceView].invoice_number);
      },
      html2canvas: { scale: 0.22 },
      // autoPaging: false,
      x: 20,
      y: 5,
      // width: 800,
      // windoWidth: 800,
      // margin: 30,
    });
    this.setState({ loadingPdf: false });
    let thisstateinvoice1 = { ...this.state.invoicePdfState, [itemid]: false };
    this.setState({ invoicePdfState: thisstateinvoice1 });
  };

  render() {
    const { invoices, invoiceView } = this.state;
    const {
      quoteToken,
      jobId,
      carrierData,
      receiverData,
      bookingData,
      payInfoData,
    } = this.props;
    const customerData = this.billingCustomer();
    // console.log(this.state,'this.state')
    // if (!jobData || Object.keys(jobData).length === 0) return false
    // if (!invoices || invoices.length === 0) return false

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Revenue Information</h4>
        </div>
        <Card.Body>
          <Row style={{ overflow: "auto" }}>
            <Table borderless size="sm">
              <thead>
                <tr>
                  <th style={this.state.borderStyle}>#</th>
                  <th style={this.state.borderStyle}>Item Name</th>
                  <th style={this.state.borderStyle}>Desc</th>
                  <th style={this.state.borderStyle}>Currency</th>
                  <th style={this.state.borderStyle}>FC Amount</th>
                  <th style={this.state.borderStyle}>Exchg Rate</th>
                  <th style={this.state.borderStyle}>LC Amt</th>
                  <th style={this.state.borderStyle}>Vat (%)</th>
                  <th style={this.state.borderStyle}>Vat Amount</th>
                  <th style={this.state.borderStyle}>Total Amt</th>
                  <th style={this.state.borderStyle}>Remark</th>
                  <th style={this.state.borderStyle}>Status</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: "#efeeee4d" }}>
                {invoices &&
                  invoices.length > 0 &&
                  invoices.map((item, i) => {
                    return item.item.map((val, index) => {
                      return (
                        <tr key={index} style={{ borderBottom: "1px solid #ddd", backgroundColor:`${item.draft ? "white" : 'rgb(214 206 142)'}` }}>
                          {index === 0 && (
                            <td
                              style={this.state.borderStyle}
                              rowSpan={item.item.length}
                            >
                              {i + 1}
                            </td>
                          )}
                          <td style={this.state.borderStyle}>
                            {val.item_name}
                          </td>
                          <td style={this.state.borderStyle}>
                            {val.description}
                          </td>
                          <td style={this.state.borderStyle}>
                            {typeof val.currency === "object" &&
                              val.currency.cc}
                          </td>
                          <td style={this.state.borderStyle}>
                            {val.rate_per_qty}
                          </td>
                          <td style={this.state.borderStyle}>{val.ex_rate}</td>
                          <td style={this.state.borderStyle}>
                            {val.lc_amount}
                          </td>
                          <td style={this.state.borderStyle}>
                            {val.vat === 2 || val.vat === 4 ? 0 : 5}
                          </td>
                          <td style={this.state.borderStyle}>
                            {val.taxable_amount}
                          </td>
                          {index === 0 && (
                            <>
                              <td
                                style={this.state.borderStyle}
                                rowSpan={item.item.length}
                              >
                                {item.gross_amount
                                  ? helperFunction.handleDecimalPoints(
                                      item.gross_amount,
                                      3
                                    )
                                  : item.gross_amount}
                              </td>
                              <td
                                style={this.state.borderStyle}
                                rowSpan={item.item.length}
                              >
                                {item.remark}
                              </td>
                              <td
                                style={this.state.borderStyle}
                                rowSpan={item.item.length}
                              >
                                {item.status}
                              </td>
                              <td rowSpan={item.item.length}>
                                {(item.draft && !this.props.isview) && (
                                  <Button
                                    variant="success"
                                    onClick={() => this.addtoQuickBook(item)}
                                    className="m-1 p-1 fs-5"
                                  >
                                    QB
                                    {/* <RiShareBoxLine /> */}
                                  </Button>
                                )}
                                <Button
                                  onClick={() => this.handleShow(true, i)}
                                  className="m-1"
                                >
                                  <FaStreetView />
                                </Button>
                                {
                                <Button
                                  className="m-1"
                                  onClick={() =>
                                    this.downloadPdf(
                                      invoices,
                                      i,
                                      quoteToken,
                                      carrierData,
                                      receiverData,
                                      customerData,
                                      jobId,
                                      bookingData,
                                      item._id
                                    )
                                  }
                                >
                                  {(this.state.invoicePdfState[item._id] && (
                                    <Spinner
                                      as="span"
                                      animation="grow"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  )) || <FaDownload />}
                                </Button>
                                }
                                {/* {item.draft && <> */}
                                {
                                  !this.props.isview &&
                                <Button
                                  variant="warning"
                                  className="m-1"
                                  onClick={() =>
                                    this.handleShowEditInvoide(true, i)
                                  }
                                >
                                  <FaEdit />
                                </Button>
                                }
                                {item?.status === "unpaid" && !this.props.isview ? (
                                  <Button
                                    variant="danger"
                                    className="m-1"
                                    onClick={() => {
                                      this.handleDeleteShow(true);
                                      this.setState({
                                        deletedInvoiceId: {
                                          id: item._id,
                                          qid: item?.quickBookdata?.invoice_id,
                                        },
                                      });
                                      /*  this.handleDelete(
                                                                 item._id,
                                                                 item.quickBookdata.invoice_id
                                                                 )*/
                                    }}
                                  >
                                    <FaTrashAlt />
                                  </Button>
                                ) : (
                                  ""
                                )}
                                {/* </>} */}
                              </td>
                            </>
                          )}
                        </tr>
                        // <tr>
                        //     <td>{i + 1}</td>
                        //     <td>
                        //         <Table>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.item_name}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.description}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>

                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>
                        //                         {typeof val.currency === "object" &&
                        //                             val.currency.cc}
                        //                     </td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.rate_per_qty}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.ex_rate}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.lc_amount}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>
                        //                         {val.vat === 2 || val.vat === 4 ? 0 : 5}
                        //                     </td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>
                        //         <Table style={{height:(this.myRef?.current?.offsetHeight && (this.myRef?.current?.offsetHeight))}}>
                        //             {item.item.map((val) => (
                        //                 <tr>
                        //                     <td>{val.taxable_amount}</td>
                        //                 </tr>
                        //             ))}
                        //         </Table>
                        //     </td>
                        //     <td>{item.gross_amount}</td>
                        //     <td>{item.remark}</td>
                        //     <td>{item.status}</td>

                        //     <td>
                        //         <Button onClick={() => this.handleShow(true, i)} className="m-1">
                        //             <FaStreetView/>
                        //         </Button>
                        //         <Button  className="m-1"
                        //         onClick={() => this.downloadPdf(invoices,i,quoteToken,carrierData,receiverData,customerData,jobId,bookingData,item._id)}>
                        //             {this.state.invoicePdfState[item._id] &&
                        //                   <Spinner
                        //                   as="span"
                        //                   animation="grow"
                        //                   size="sm"
                        //                   role="status"
                        //                   aria-hidden="true"
                        //               />
                        //                 || <FaDownload />
                        //             }
                        //             </Button>

                        //         <Button
                        //             variant="warning"
                        //             className="m-1"
                        //             onClick={() => this.handleShowEditInvoide(true, i)}
                        //         >
                        //             <FaEdit/>
                        //         </Button>
                        //                 {item?.status === 'unpaid' ?
                        //         <Button
                        //             variant="danger"
                        //             className="m-1"
                        //             onClick={() => {
                        //                 this.handleDeleteShow(true)
                        //                 this.setState({ deletedInvoiceId: { id: item._id, qid: item.quickBookdata.invoice_id } })
                        //                 /*  this.handleDelete(
                        //                      item._id,
                        //                      item.quickBookdata.invoice_id
                        //                      )*/
                        //             }}
                        //         >
                        //             <FaTrashAlt/>
                        //         </Button> : ''}
                        //     </td>
                        // </tr>
                      );
                    });
                  })}
              </tbody>
            </Table>
          </Row>

          {this.getRevForms()}

          {invoices && invoices.length > 0 && (
            <Modal
              size="xl"
              show={this.state.showModal}
              onHide={() => this.handleShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  Invoice
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <InvoiceHtml
                  invoiceItem={invoices[invoiceView]}
                  quoteToken={quoteToken}
                  carrierData={carrierData}
                  receiverData={receiverData}
                  customerData={customerData}
                  jobId={jobId}
                  bookingData={bookingData}
                />
              </Modal.Body>
            </Modal>
          )}

          {invoices && invoices.length > 0 && (
            <Modal
              size="xl"
              show={this.state.showEditInvoicesModal}
              onHide={() => this.handleShowEditInvoide(false)}
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  Invoice
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditInvoice
                  invoiceModal={this.handleShowEditInvoide}
                  invoiceItem={invoices[invoiceView]}
                  quoteToken={quoteToken}
                  carrierData={carrierData}
                  receiverData={receiverData}
                  jobId={jobId}
                  profitNLoss={this.props.profitNLoss}
                />
              </Modal.Body>
            </Modal>
          )}

          {this.state.showDeleteModal && (
            <DeleteModal
              modalShow={this.state.showDeleteModal}
              handleDeleteShow={this.handleDeleteShow}
              handleDelete={this.handleDelete}
            />
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default Revenue;
